import Immutable from 'immutable';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import pathfinder from '@fiverr-private/pathfinder';

const UPDATE_REVIEWS = 'reviews/update_reviews';

const PAGE_SIZE = 5;

const initialState = Immutable.fromJS({});

export default function(state = initialState, action = {}) {

    switch (action.type) {
        case UPDATE_REVIEWS:
            const newStarsList = action.isFilter ? action.list.stars : state.get('stars').push(...action.list.stars).toJS();
            state = state.update('stars', () => Immutable.fromJS(newStarsList));
            state = state.update('has_more_pages', () => action.list.has_more_pages);
            state = state.update('type', () => action.filterType);
            return state;
        default:
            return state;
    }
}

export function updateReviews(list, filterType, isFilter) {
    return {
        type: UPDATE_REVIEWS,
        filterType,
        isFilter,
        list
    };
}

/** Load More & Order By reviews */
export function fetchReviews(event, type, lastStar, pathFinderConfig) {
    return function(dispatch, state) {

        const isFilter = event.target.tagName === 'SELECT',
            filterType = (isFilter) ? event.target.value : type,
            gigId = state().get('gigId');

        let idType = 'user',
            id = state().get('userId'),
            url;

        if (gigId) {
            idType = 'gig';
            id = gigId;
        }

        if (pathFinderConfig){
            const { path, params } = pathFinderConfig.toObject();
            url = `${pathfinder(path, params.toObject())}?${idType}_id=${id}`;
        } else {
            url = `/ratings/index?${idType}_id=${id}&page_size=${PAGE_SIZE}`;
        }

        if (!isFilter && lastStar) {
            url += `&last_star_rating_id=${lastStar}`;
        }

        if (filterType) {
            url += `&type=${filterType}`;
        }

        gofor(url)
            .then((response) => {
                if (!response.ok) { throw new Error(response.statusText); }

                return response.json();
            })
            .then((res) => {
                dispatch(updateReviews(res, filterType, isFilter));
            });
    };
}



// WEBPACK FOOTER //
// ./src/reviews/module/index.js